import instance from "@/services/axiosConfig";

const chartService = {
  getChartAssignments: async (type) =>
    instance.get(`/charts/getAllAssignments?itemType=${type}`),

  createOwnerAssignment: async (payload) =>
    instance.post(`/charts/assign-feature`, payload),

  updateOwnerAssignment: async (payload) =>
    instance.put(`/charts/updateAssignmentToOwner`, payload),
  getAllProcessedView: async () => instance.get(`/charts/getprocesseddata`),
  addChartfavouritesettings: async (payload) =>
    instance.post(`/chartsettings/favorites`, payload),
  getallFavourites: async () =>
    instance.get(`/chartsettings/favorites`),
 getFavouritebyId: async (id) =>
    instance.get(`/chartsettings/favorites/${id}`)

};
export default chartService;
